<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="textblock !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <button withRight="admin.textblock.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
          <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12">
        <app-form-control [cid]="'identifier'" [control]="form.get('identifier')" [type]="'input'" [label]="t('common.labels.identifier')" [edit]="inEdit" [basevalue]="textblock.identifier"></app-form-control>
        <app-form-control [cid]="'type'" [control]="form.get('type')" [type]="'select'" [label]="t('common.labels.type')" [options]="optionsTypes" [edit]="inEdit" [basevalue]="t('common.labels.' + textblock.type)"></app-form-control>
        <app-form-control [cid]="'description'" [control]="form.get('description')" [type]="'textarea'" [label]="t('common.labels.description')" [edit]="inEdit" [basevalue]="textblock.description"></app-form-control>
      </div>
    </div>

  </form>
</ng-container>
